
    import NavigationHeader from '@/components/core/NavigationHeader';
       import BackHeader from '@/components/core/BackHeader';
    import Footer from '@/components/core/Footer';

    export default {
      components: {
        NavigationHeader,
        BackHeader,
        Footer
      },
      head() {
    return {
      meta: [
        { hid: 'og:url',
        property: 'og:url',
        content: this.$config.siteUrl + this.$route.path
      },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: 'https://www.goa.app' + this.$route.path
        }
      ]
    }
  },
    }

  